import type { MfaVerifyRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useVerifyMfa() {
  return useApiMutation("post", "/auth/mfa/verify", {
    notify: false,
    mapVariables: (data: MfaVerifyRequestDto) => ({
      body: data,
      headers: {
        "x-auth-request": "true",
      },
      credentials: "include",
    }),
  });
}
